export default class ReactNativeSound {
    constructor(file) {
        this.audio = new Audio(file);
        this.canPlay = false;
        this.audio.addEventListener("canplaythrough", event => {
            /* 音频可以播放；如果权限允许则播放 */
            this.canPlay = true;
        });
        this.audio.addEventListener("loadeddata", () => {
            let duration = this.audio.duration;
            // duration 变量现在存放音频的播放时长（单位秒）
        });
    }

    stop() {
        if (this.canPlay) {
            return this.audio.pause();
        } else {
            return Promise.reject("can not play");
        }
    }

    pause() {
        if (this.canPlay) {
            return this.audio.pause();
        } else {
            return Promise.reject("can not play");
        }
    }

    play() {
        if (this.canPlay) {
            return this.audio.play();
        } else {
            return Promise.reject("can not play");
        }
    }
}
